import api from './ApiService';

export async function updateProfile(id, params) {
  const { data } = await api.patch(`profile/${id}`, params);
  return data;
}
